var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CountdownProvider", {
    attrs: { date: _vm.dateAsTime },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var days = ref.days
          var hours = ref.hours
          var minutes = ref.minutes
          var seconds = ref.seconds
          return [
            _c(
              "div",
              {
                staticClass:
                  "absolute inset-0 bg-black flex flex-col items-center justify-center text-white",
              },
              [
                _c("div", { staticClass: "uppercase sm:text-lg opacity-40" }, [
                  _vm._v("\n      Stream starting\n    "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex py-3" }, [
                  _c("div", { staticClass: "lc-countdown-tick" }, [
                    _vm._v("\n        " + _vm._s(days) + "\n        "),
                    _c("div", { staticClass: "lc-countdown-unit" }, [
                      _vm._v("days"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lc-countdown-separator" }, [
                    _vm._v(":"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lc-countdown-tick" }, [
                    _vm._v("\n        " + _vm._s(hours) + "\n        "),
                    _c("div", { staticClass: "lc-countdown-unit" }, [
                      _vm._v("hours"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lc-countdown-separator" }, [
                    _vm._v(":"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lc-countdown-tick" }, [
                    _vm._v("\n        " + _vm._s(minutes) + "\n        "),
                    _c("div", { staticClass: "lc-countdown-unit" }, [
                      _vm._v("minutes"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lc-countdown-separator" }, [
                    _vm._v(":"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lc-countdown-tick" }, [
                    _vm._v("\n        " + _vm._s(seconds) + "\n        "),
                    _c("div", { staticClass: "lc-countdown-unit" }, [
                      _vm._v("seconds"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "lc-countdown-timezones" }, [
                  _c("div", [_vm._v(_vm._s(_vm.newYorkTime) + " (New York)")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "opacity-60" }, [_vm._v("/")]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.genevaTime) + " (Geneva)")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "opacity-60" }, [_vm._v("/")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.jerusalemTime) + " (Jerusalem)"),
                  ]),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }